import { useNavigate } from "react-router-dom";
import { ArrowLeft, BookOpen } from "lucide-react";
import ProfileMenu from "../../components/layout/ProfileMenu";
import ClassesManager from "./components/ClassesManager";

export default function TurmasPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{ backgroundColor: "#f8f9fa" }}>
      <header
        className="bg-white shadow-sm border-b sticky top-0 z-50"
        style={{ borderColor: "#e0e0e0" }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center gap-3">
              <button
                onClick={() => navigate("/dashboard")}
                className="p-2 hover:bg-gray-100 rounded-lg transition mr-2"
                title="Voltar para Dashboard"
              >
                <ArrowLeft className="w-5 h-5 text-gray-600" />
              </button>
              <div
                className="w-10 h-10 rounded-lg flex items-center justify-center"
                style={{ backgroundColor: "#1967d2" }}
              >
                <BookOpen className="w-6 h-6 text-white" />
              </div>
              <h1
                className="text-xl font-semibold"
                style={{ color: "#202124" }}
              >
                Gerenciamento de Turmas
              </h1>
            </div>

            <div className="flex items-center gap-4">
              <ProfileMenu />
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <ClassesManager />
      </main>
    </div>
  );
}
